export interface CountryCode {
  label: string;
  value: string;
  countryCode: string;
  country: string;
}

export const countryCodes: CountryCode[] = [
  {
    label: 'Austria AT +43',
    value: '+43',
    countryCode: 'AT',
    country: 'Austria',
  },
  {
    label: 'Germany DE +49',
    value: '+49',
    countryCode: 'DE',
    country: 'Germany',
  },
  {
    label: 'Afghanistan AF +93',
    value: '+93',
    countryCode: 'AF',
    country: 'Afghanistan',
  },
  {
    label: 'Åland Islands AX +358',
    value: '+358',
    countryCode: 'AX',
    country: 'Åland Islands',
  },
  {
    label: 'Albania AL +355',
    value: '+355',
    countryCode: 'AL',
    country: 'Albania',
  },
  {
    label: 'Algeria DZ +213',
    value: '+213',
    countryCode: 'DZ',
    country: 'Algeria',
  },
  {
    label: 'American Samoa AS +1684',
    value: '+1684',
    countryCode: 'AS',
    country: 'American Samoa',
  },
  {
    label: 'Andorra AD +376',
    value: '+376',
    countryCode: 'AD',
    country: 'Andorra',
  },
  {
    label: 'Angola AO +244',
    value: '+244',
    countryCode: 'AO',
    country: 'Angola',
  },
  {
    label: 'Anguilla AI +1264',
    value: '+1264',
    countryCode: 'AI',
    country: 'Anguilla',
  },
  {
    label: 'Antarctica AQ +672',
    value: '+672',
    countryCode: 'AQ',
    country: 'Antarctica',
  },
  {
    label: 'Antigua and Barbuda AG +1268',
    value: '+1268',
    countryCode: 'AG',
    country: 'Antigua and Barbuda',
  },
  {
    label: 'Argentina AR +54',
    value: '+54',
    countryCode: 'AR',
    country: 'Argentina',
  },
  {
    label: 'Armenia AM +374',
    value: '+374',
    countryCode: 'AM',
    country: 'Armenia',
  },
  {
    label: 'Australia AU +61',
    value: '+61',
    countryCode: 'AU',
    country: 'Australia',
  },
  {
    label: 'Aruba AW +297',
    value: '+297',
    countryCode: 'AW',
    country: 'Aruba',
  },
  {
    label: 'Azerbaijan AZ +994',
    value: '+994',
    countryCode: 'AZ',
    country: 'Azerbaijan',
  },
  {
    label: 'Bahamas BS +1242',
    value: '+1242',
    countryCode: 'BS',
    country: 'Bahamas',
  },
  {
    label: 'Bahrain BH +973',
    value: '+973',
    countryCode: 'BH',
    country: 'Bahrain',
  },
  {
    label: 'Bangladesh BD +880',
    value: '+880',
    countryCode: 'BD',
    country: 'Bangladesh',
  },
  {
    label: 'Barbados BB +1246',
    value: '+1246',
    countryCode: 'BB',
    country: 'Barbados',
  },
  {
    label: 'Belarus BY +375',
    value: '+375',
    countryCode: 'BY',
    country: 'Belarus',
  },
  {
    label: 'Belgium BE +32',
    value: '+32',
    countryCode: 'BE',
    country: 'Belgium',
  },
  {
    label: 'Belize BZ +501',
    value: '+501',
    countryCode: 'BZ',
    country: 'Belize',
  },
  {
    label: 'Benin BJ +229',
    value: '+229',
    countryCode: 'BJ',
    country: 'Benin',
  },
  {
    label: 'Bermuda BM +1441',
    value: '+1441',
    countryCode: 'BM',
    country: 'Bermuda',
  },
  {
    label: 'Bhutan BT +975',
    value: '+975',
    countryCode: 'BT',
    country: 'Bhutan',
  },
  {
    label: 'Bolivia BO +591',
    value: '+591',
    countryCode: 'BO',
    country: 'Bolivia',
  },
  {
    label: 'Bosnia and Herzegovina BA +387',
    value: '+387',
    countryCode: 'BA',
    country: 'Bosnia and Herzegovina',
  },
  {
    label: 'Botswana BW +267',
    value: '+267',
    countryCode: 'BW',
    country: 'Botswana',
  },
  {
    label: 'Brazil BR +55',
    value: '+55',
    countryCode: 'BR',
    country: 'Brazil',
  },
  {
    label: 'British Indian Ocean Territory IO +246',
    value: '+246',
    countryCode: 'IO',
    country: 'British Indian Ocean Territory',
  },
  {
    label: 'Brunei Darussalam BN +673',
    value: '+673',
    countryCode: 'BN',
    country: 'Brunei Darussalam',
  },
  {
    label: 'Bulgaria BG +359',
    value: '+359',
    countryCode: 'BG',
    country: 'Bulgaria',
  },
  {
    label: 'Burkina Faso BF +226',
    value: '+226',
    countryCode: 'BF',
    country: 'Burkina Faso',
  },
  {
    label: 'Burundi BI +257',
    value: '+257',
    countryCode: 'BI',
    country: 'Burundi',
  },
  {
    label: 'Cambodia KH +855',
    value: '+855',
    countryCode: 'KH',
    country: 'Cambodia',
  },
  {
    label: 'Cameroon CM +237',
    value: '+237',
    countryCode: 'CM',
    country: 'Cameroon',
  },
  {
    label: 'Canada CA +1',
    value: '+1',
    countryCode: 'CA',
    country: 'Canada',
  },
  {
    label: 'Cape Verde CV +238',
    value: '+238',
    countryCode: 'CV',
    country: 'Cape Verde',
  },
  {
    label: 'Cayman Islands KY +345',
    value: '+345',
    countryCode: 'KY',
    country: 'Cayman Islands',
  },
  {
    label: 'Central African Republic CF +236',
    value: '+236',
    countryCode: 'CF',
    country: 'Central African Republic',
  },
  {
    label: 'Chad TD +235',
    value: '+235',
    countryCode: 'TD',
    country: 'Chad',
  },
  {
    label: 'Chile CL +56',
    value: '+56',
    countryCode: 'CL',
    country: 'Chile',
  },
  {
    label: 'China CN +86',
    value: '+86',
    countryCode: 'CN',
    country: 'China',
  },
  {
    label: 'Christmas Island CX +61',
    value: '+61',
    countryCode: 'CX',
    country: 'Christmas Island',
  },
  {
    label: 'Cocos (Keeling) Islands CC +61',
    value: '+61',
    countryCode: 'CC',
    country: 'Cocos (Keeling) Islands',
  },
  {
    label: 'Colombia CO +57',
    value: '+57',
    countryCode: 'CO',
    country: 'Colombia',
  },
  {
    label: 'Comoros KM +269',
    value: '+269',
    countryCode: 'KM',
    country: 'Comoros',
  },
  {
    label: 'Congo CG +242',
    value: '+242',
    countryCode: 'CG',
    country: 'Congo',
  },
  {
    label: 'Congo, Democratic Republic of the CD +243',
    value: '+243',
    countryCode: 'CD',
    country: 'Congo, Democratic Republic of the',
  },
  {
    label: 'Cook Islands CK +682',
    value: '+682',
    countryCode: 'CK',
    country: 'Cook Islands',
  },
  {
    label: 'Costa Rica CR +506',
    value: '+506',
    countryCode: 'CR',
    country: 'Costa Rica',
  },
  {
    label: "Côte d'Ivoire CI +225",
    value: '+225',
    countryCode: 'CI',
    country: "Côte d'Ivoire",
  },
  {
    label: 'Croatia HR +385',
    value: '+385',
    countryCode: 'HR',
    country: 'Croatia',
  },
  {
    label: 'Cuba CU +53',
    value: '+53',
    countryCode: 'CU',
    country: 'Cuba',
  },
  {
    label: 'Cyprus CY +357',
    value: '+357',
    countryCode: 'CY',
    country: 'Cyprus',
  },
  {
    label: 'Czech Republic CZ +420',
    value: '+420',
    countryCode: 'CZ',
    country: 'Czech Republic',
  },
  {
    label: 'Denmark DK +45',
    value: '+45',
    countryCode: 'DK',
    country: 'Denmark',
  },
  {
    label: 'Djibouti DJ +253',
    value: '+253',
    countryCode: 'DJ',
    country: 'Djibouti',
  },
  {
    label: 'Dominica DM +1767',
    value: '+1767',
    countryCode: 'DM',
    country: 'Dominica',
  },
  {
    label: 'Dominican Republic DO +1849',
    value: '+1849',
    countryCode: 'DO',
    country: 'Dominican Republic',
  },
  {
    label: 'Ecuador EC +593',
    value: '+593',
    countryCode: 'EC',
    country: 'Ecuador',
  },
  {
    label: 'Egypt EG +20',
    value: '+20',
    countryCode: 'EG',
    country: 'Egypt',
  },
  {
    label: 'El Salvador SV +503',
    value: '+503',
    countryCode: 'SV',
    country: 'El Salvador',
  },
  {
    label: 'Equatorial Guinea GQ +240',
    value: '+240',
    countryCode: 'GQ',
    country: 'Equatorial Guinea',
  },
  {
    label: 'Eritrea ER +291',
    value: '+291',
    countryCode: 'ER',
    country: 'Eritrea',
  },
  {
    label: 'Estonia EE +372',
    value: '+372',
    countryCode: 'EE',
    country: 'Estonia',
  },
  {
    label: 'Ethiopia ET +251',
    value: '+251',
    countryCode: 'ET',
    country: 'Ethiopia',
  },
  {
    label: 'Falkland Islands (Malvinas) FK +500',
    value: '+500',
    countryCode: 'FK',
    country: 'Falkland Islands (Malvinas)',
  },
  {
    label: 'Faroe Islands FO +298',
    value: '+298',
    countryCode: 'FO',
    country: 'Faroe Islands',
  },
  {
    label: 'Fiji FJ +679',
    value: '+679',
    countryCode: 'FJ',
    country: 'Fiji',
  },
  {
    label: 'Finland FI +358',
    value: '+358',
    countryCode: 'FI',
    country: 'Finland',
  },
  {
    label: 'France FR +33',
    value: '+33',
    countryCode: 'FR',
    country: 'France',
  },
  {
    label: 'French Guiana GF +594',
    value: '+594',
    countryCode: 'GF',
    country: 'French Guiana',
  },
  {
    label: 'French Polynesia PF +689',
    value: '+689',
    countryCode: 'PF',
    country: 'French Polynesia',
  },
  {
    label: 'Gabon GA +241',
    value: '+241',
    countryCode: 'GA',
    country: 'Gabon',
  },
  {
    label: 'Gambia GM +220',
    value: '+220',
    countryCode: 'GM',
    country: 'Gambia',
  },
  {
    label: 'Georgia GE +995',
    value: '+995',
    countryCode: 'GE',
    country: 'Georgia',
  },
  {
    label: 'Ghana GH +233',
    value: '+233',
    countryCode: 'GH',
    country: 'Ghana',
  },
  {
    label: 'Gibraltar GI +350',
    value: '+350',
    countryCode: 'GI',
    country: 'Gibraltar',
  },
  {
    label: 'Greece GR +30',
    value: '+30',
    countryCode: 'GR',
    country: 'Greece',
  },
  {
    label: 'Greenland GL +299',
    value: '+299',
    countryCode: 'GL',
    country: 'Greenland',
  },
  {
    label: 'Grenada GD +1473',
    value: '+1473',
    countryCode: 'GD',
    country: 'Grenada',
  },
  {
    label: 'Guadeloupe GP +590',
    value: '+590',
    countryCode: 'GP',
    country: 'Guadeloupe',
  },
  {
    label: 'Guam GU +1671',
    value: '+1671',
    countryCode: 'GU',
    country: 'Guam',
  },
  {
    label: 'Guatemala GT +502',
    value: '+502',
    countryCode: 'GT',
    country: 'Guatemala',
  },
  {
    label: 'Guernsey GG +44',
    value: '+44',
    countryCode: 'GG',
    country: 'Guernsey',
  },
  {
    label: 'Guinea GN +224',
    value: '+224',
    countryCode: 'GN',
    country: 'Guinea',
  },
  {
    label: 'Guinea-Bissau GW +245',
    value: '+245',
    countryCode: 'GW',
    country: 'Guinea-Bissau',
  },
  {
    label: 'Guyana GY +592',
    value: '+592',
    countryCode: 'GY',
    country: 'Guyana',
  },
  {
    label: 'Haiti HT +509',
    value: '+509',
    countryCode: 'HT',
    country: 'Haiti',
  },
  {
    label: 'Holy See (Vatican City State) VA +379',
    value: '+379',
    countryCode: 'VA',
    country: 'Holy See (Vatican City State)',
  },
  {
    label: 'Honduras HN +504',
    value: '+504',
    countryCode: 'HN',
    country: 'Honduras',
  },
  {
    label: 'Hong Kong HK +852',
    value: '+852',
    countryCode: 'HK',
    country: 'Hong Kong',
  },
  {
    label: 'Hungary HU +36',
    value: '+36',
    countryCode: 'HU',
    country: 'Hungary',
  },
  {
    label: 'Iceland IS +354',
    value: '+354',
    countryCode: 'IS',
    country: 'Iceland',
  },
  {
    label: 'India IN +91',
    value: '+91',
    countryCode: 'IN',
    country: 'India',
  },
  {
    label: 'Indonesia ID +62',
    value: '+62',
    countryCode: 'ID',
    country: 'Indonesia',
  },
  {
    label: 'Iran, Islamic Republic of IR +98',
    value: '+98',
    countryCode: 'IR',
    country: 'Iran, Islamic Republic of',
  },
  {
    label: 'Iraq IQ +964',
    value: '+964',
    countryCode: 'IQ',
    country: 'Iraq',
  },
  {
    label: 'Ireland IE +353',
    value: '+353',
    countryCode: 'IE',
    country: 'Ireland',
  },
  {
    label: 'Isle of Man IM +44',
    value: '+44',
    countryCode: 'IM',
    country: 'Isle of Man',
  },
  {
    label: 'Israel IL +972',
    value: '+972',
    countryCode: 'IL',
    country: 'Israel',
  },
  {
    label: 'Italy IT +39',
    value: '+39',
    countryCode: 'IT',
    country: 'Italy',
  },
  {
    label: 'Jamaica JM +1876',
    value: '+1876',
    countryCode: 'JM',
    country: 'Jamaica',
  },
  {
    label: 'Japan JP +81',
    value: '+81',
    countryCode: 'JP',
    country: 'Japan',
  },
  {
    label: 'Jersey JE +44',
    value: '+44',
    countryCode: 'JE',
    country: 'Jersey',
  },
  {
    label: 'Jordan JO +962',
    value: '+962',
    countryCode: 'JO',
    country: 'Jordan',
  },
  {
    label: 'Kazakhstan KZ +77',
    value: '+77',
    countryCode: 'KZ',
    country: 'Kazakhstan',
  },
  {
    label: 'Kenya KE +254',
    value: '+254',
    countryCode: 'KE',
    country: 'Kenya',
  },
  {
    label: 'Kiribati KI +686',
    value: '+686',
    countryCode: 'KI',
    country: 'Kiribati',
  },
  {
    label: "Korea, Democratic People's Republic of KP +850",
    value: '+850',
    countryCode: 'KP',
    country: "Korea, Democratic People's Republic of",
  },
  {
    label: 'Korea, Republic of KR +82',
    value: '+82',
    countryCode: 'KR',
    country: 'Korea, Republic of',
  },
  {
    label: 'Kuwait KW +965',
    value: '+965',
    countryCode: 'KW',
    country: 'Kuwait',
  },
  {
    label: 'Kyrgyzstan KG +996',
    value: '+996',
    countryCode: 'KG',
    country: 'Kyrgyzstan',
  },
  {
    label: "Lao People's Democratic Republic LA +856",
    value: '+856',
    countryCode: 'LA',
    country: "Lao People's Democratic Republic",
  },
  {
    label: 'Latvia LV +371',
    value: '+371',
    countryCode: 'LV',
    country: 'Latvia',
  },
  {
    label: 'Lebanon LB +961',
    value: '+961',
    countryCode: 'LB',
    country: 'Lebanon',
  },
  {
    label: 'Lesotho LS +266',
    value: '+266',
    countryCode: 'LS',
    country: 'Lesotho',
  },
  {
    label: 'Liberia LR +231',
    value: '+231',
    countryCode: 'LR',
    country: 'Liberia',
  },
  {
    label: 'Libya LY +218',
    value: '+218',
    countryCode: 'LY',
    country: 'Libya',
  },
  {
    label: 'Liechtenstein LI +423',
    value: '+423',
    countryCode: 'LI',
    country: 'Liechtenstein',
  },
  {
    label: 'Lithuania LT +370',
    value: '+370',
    countryCode: 'LT',
    country: 'Lithuania',
  },
  {
    label: 'Luxembourg LU +352',
    value: '+352',
    countryCode: 'LU',
    country: 'Luxembourg',
  },
  {
    label: 'Macao MO +853',
    value: '+853',
    countryCode: 'MO',
    country: 'Macao',
  },
  {
    label: 'North Macedonia MK +389',
    value: '+389',
    countryCode: 'MK',
    country: 'North Macedonia',
  },
  {
    label: 'Madagascar MG +261',
    value: '+261',
    countryCode: 'MG',
    country: 'Madagascar',
  },
  {
    label: 'Malawi MW +265',
    value: '+265',
    countryCode: 'MW',
    country: 'Malawi',
  },
  {
    label: 'Malaysia MY +60',
    value: '+60',
    countryCode: 'MY',
    country: 'Malaysia',
  },
  {
    label: 'Maldives MV +960',
    value: '+960',
    countryCode: 'MV',
    country: 'Maldives',
  },
  {
    label: 'Mali ML +223',
    value: '+223',
    countryCode: 'ML',
    country: 'Mali',
  },
  {
    label: 'Malta MT +356',
    value: '+356',
    countryCode: 'MT',
    country: 'Malta',
  },
  {
    label: 'Marshall Islands MH +692',
    value: '+692',
    countryCode: 'MH',
    country: 'Marshall Islands',
  },
  {
    label: 'Martinique MQ +596',
    value: '+596',
    countryCode: 'MQ',
    country: 'Martinique',
  },
  {
    label: 'Mauritania MR +222',
    value: '+222',
    countryCode: 'MR',
    country: 'Mauritania',
  },
  {
    label: 'Mauritius MU +230',
    value: '+230',
    countryCode: 'MU',
    country: 'Mauritius',
  },
  {
    label: 'Mayotte YT +262',
    value: '+262',
    countryCode: 'YT',
    country: 'Mayotte',
  },
  {
    label: 'Mexico MX +52',
    value: '+52',
    countryCode: 'MX',
    country: 'Mexico',
  },
  {
    label: 'Micronesia, Federated States of FM +691',
    value: '+691',
    countryCode: 'FM',
    country: 'Micronesia, Federated States of',
  },
  {
    label: 'Moldova, Republic of MD +373',
    value: '+373',
    countryCode: 'MD',
    country: 'Moldova, Republic of',
  },
  {
    label: 'Monaco MC +377',
    value: '+377',
    countryCode: 'MC',
    country: 'Monaco',
  },
  {
    label: 'Mongolia MN +976',
    value: '+976',
    countryCode: 'MN',
    country: 'Mongolia',
  },
  {
    label: 'Montenegro ME +382',
    value: '+382',
    countryCode: 'ME',
    country: 'Montenegro',
  },
  {
    label: 'Montserrat MS +1664',
    value: '+1664',
    countryCode: 'MS',
    country: 'Montserrat',
  },
  {
    label: 'Morocco MA +212',
    value: '+212',
    countryCode: 'MA',
    country: 'Morocco',
  },
  {
    label: 'Mozambique MZ +258',
    value: '+258',
    countryCode: 'MZ',
    country: 'Mozambique',
  },
  {
    label: 'Myanmar MM +95',
    value: '+95',
    countryCode: 'MM',
    country: 'Myanmar',
  },
  {
    label: 'Namibia NA +264',
    value: '+264',
    countryCode: 'NA',
    country: 'Namibia',
  },
  {
    label: 'Nauru NR +674',
    value: '+674',
    countryCode: 'NR',
    country: 'Nauru',
  },
  {
    label: 'Nepal NP +977',
    value: '+977',
    countryCode: 'NP',
    country: 'Nepal',
  },
  {
    label: 'Netherlands NL +31',
    value: '+31',
    countryCode: 'NL',
    country: 'Netherlands',
  },
  {
    label: 'New Caledonia NC +687',
    value: '+687',
    countryCode: 'NC',
    country: 'New Caledonia',
  },
  {
    label: 'New Zealand NZ +64',
    value: '+64',
    countryCode: 'NZ',
    country: 'New Zealand',
  },
  {
    label: 'Nicaragua NI +505',
    value: '+505',
    countryCode: 'NI',
    country: 'Nicaragua',
  },
  {
    label: 'Niger NE +227',
    value: '+227',
    countryCode: 'NE',
    country: 'Niger',
  },
  {
    label: 'Nigeria NG +234',
    value: '+234',
    countryCode: 'NG',
    country: 'Nigeria',
  },
  {
    label: 'Niue NU +683',
    value: '+683',
    countryCode: 'NU',
    country: 'Niue',
  },
  {
    label: 'Norfolk Island NF +672',
    value: '+672',
    countryCode: 'NF',
    country: 'Norfolk Island',
  },
  {
    label: 'Northern Mariana Islands MP +1670',
    value: '+1670',
    countryCode: 'MP',
    country: 'Northern Mariana Islands',
  },
  {
    label: 'Norway NO +47',
    value: '+47',
    countryCode: 'NO',
    country: 'Norway',
  },
  {
    label: 'Oman OM +968',
    value: '+968',
    countryCode: 'OM',
    country: 'Oman',
  },
  {
    label: 'Pakistan PK +92',
    value: '+92',
    countryCode: 'PK',
    country: 'Pakistan',
  },
  {
    label: 'Palau PW +680',
    value: '+680',
    countryCode: 'PW',
    country: 'Palau',
  },
  {
    label: 'Palestine, State of PS +970',
    value: '+970',
    countryCode: 'PS',
    country: 'Palestine, State of',
  },
  {
    label: 'Panama PA +507',
    value: '+507',
    countryCode: 'PA',
    country: 'Panama',
  },
  {
    label: 'Papua New Guinea PG +675',
    value: '+675',
    countryCode: 'PG',
    country: 'Papua New Guinea',
  },
  {
    label: 'Paraguay PY +595',
    value: '+595',
    countryCode: 'PY',
    country: 'Paraguay',
  },
  {
    label: 'Peru PE +51',
    value: '+51',
    countryCode: 'PE',
    country: 'Peru',
  },
  {
    label: 'Philippines PH +63',
    value: '+63',
    countryCode: 'PH',
    country: 'Philippines',
  },
  {
    label: 'Poland PL +48',
    value: '+48',
    countryCode: 'PL',
    country: 'Poland',
  },
  {
    label: 'Portugal PT +351',
    value: '+351',
    countryCode: 'PT',
    country: 'Portugal',
  },
  {
    label: 'Puerto Rico PR +1',
    value: '+1',
    countryCode: 'PR',
    country: 'Puerto Rico',
  },
  {
    label: 'Qatar QA +974',
    value: '+974',
    countryCode: 'QA',
    country: 'Qatar',
  },
  {
    label: 'Romania RO +40',
    value: '+40',
    countryCode: 'RO',
    country: 'Romania',
  },
  {
    label: 'Russian Federation RU +7',
    value: '+7',
    countryCode: 'RU',
    country: 'Russian Federation',
  },
  {
    label: 'Rwanda RW +250',
    value: '+250',
    countryCode: 'RW',
    country: 'Rwanda',
  },
  {
    label: 'Réunion RE +262',
    value: '+262',
    countryCode: 'RE',
    country: 'Réunion',
  },
  {
    label: 'Saint Barthélemy BL +590',
    value: '+590',
    countryCode: 'BL',
    country: 'Saint Barthélemy',
  },
  {
    label: 'Saint Kitts and Nevis KN +1869',
    value: '+1869',
    countryCode: 'KN',
    country: 'Saint Kitts and Nevis',
  },
  {
    label: 'Saint Lucia LC +1758',
    value: '+1758',
    countryCode: 'LC',
    country: 'Saint Lucia',
  },
  {
    label: 'Saint Martin (French part) MF +590',
    value: '+590',
    countryCode: 'MF',
    country: 'Saint Martin (French part)',
  },
  {
    label: 'Saint Pierre and Miquelon PM +508',
    value: '+508',
    countryCode: 'PM',
    country: 'Saint Pierre and Miquelon',
  },
  {
    label: 'Saint Vincent and the Grenadines VC +1784',
    value: '+1784',
    countryCode: 'VC',
    country: 'Saint Vincent and the Grenadines',
  },
  {
    label: 'Samoa WS +685',
    value: '+685',
    countryCode: 'WS',
    country: 'Samoa',
  },
  {
    label: 'San Marino SM +378',
    value: '+378',
    countryCode: 'SM',
    country: 'San Marino',
  },
  {
    label: 'Sao Tome and Principe ST +239',
    value: '+239',
    countryCode: 'ST',
    country: 'Sao Tome and Principe',
  },
  {
    label: 'Saudi Arabia SA +966',
    value: '+966',
    countryCode: 'SA',
    country: 'Saudi Arabia',
  },
  {
    label: 'Senegal SN +221',
    value: '+221',
    countryCode: 'SN',
    country: 'Senegal',
  },
  {
    label: 'Serbia RS +381',
    value: '+381',
    countryCode: 'RS',
    country: 'Serbia',
  },
  {
    label: 'Seychelles SC +248',
    value: '+248',
    countryCode: 'SC',
    country: 'Seychelles',
  },
  {
    label: 'Sierra Leone SL +232',
    value: '+232',
    countryCode: 'SL',
    country: 'Sierra Leone',
  },
  {
    label: 'Singapore SG +65',
    value: '+65',
    countryCode: 'SG',
    country: 'Singapore',
  },
  {
    label: 'Sint Maarten (Dutch part) SX +1721',
    value: '+1721',
    countryCode: 'SX',
    country: 'Sint Maarten (Dutch part)',
  },
  {
    label: 'Slovakia SK +421',
    value: '+421',
    countryCode: 'SK',
    country: 'Slovakia',
  },
  {
    label: 'Slovenia SI +386',
    value: '+386',
    countryCode: 'SI',
    country: 'Slovenia',
  },
  {
    label: 'Solomon Islands SB +677',
    value: '+677',
    countryCode: 'SB',
    country: 'Solomon Islands',
  },
  {
    label: 'Somalia SO +252',
    value: '+252',
    countryCode: 'SO',
    country: 'Somalia',
  },
  {
    label: 'South Africa ZA +27',
    value: '+27',
    countryCode: 'ZA',
    country: 'South Africa',
  },
  {
    label: 'South Georgia and the South Sandwich Islands GS +500',
    value: '+500',
    countryCode: 'GS',
    country: 'South Georgia and the South Sandwich Islands',
  },
  {
    label: 'South Sudan SS +211',
    value: '+211',
    countryCode: 'SS',
    country: 'South Sudan',
  },
  {
    label: 'Spain ES +34',
    value: '+34',
    countryCode: 'ES',
    country: 'Spain',
  },
  {
    label: 'Sri Lanka LK +94',
    value: '+94',
    countryCode: 'LK',
    country: 'Sri Lanka',
  },
  {
    label: 'Sudan SD +249',
    value: '+249',
    countryCode: 'SD',
    country: 'Sudan',
  },
  {
    label: 'Suriname SR +597',
    value: '+597',
    countryCode: 'SR',
    country: 'Suriname',
  },
  {
    label: 'Svalbard and Jan Mayen SJ +47',
    value: '+47',
    countryCode: 'SJ',
    country: 'Svalbard and Jan Mayen',
  },
  {
    label: 'Eswatini SZ +268',
    value: '+268',
    countryCode: 'SZ',
    country: 'Eswatini',
  },
  {
    label: 'Sweden SE +46',
    value: '+46',
    countryCode: 'SE',
    country: 'Sweden',
  },
  {
    label: 'Switzerland CH +41',
    value: '+41',
    countryCode: 'CH',
    country: 'Switzerland',
  },
  {
    label: 'Syrian Arab Republic SY +963',
    value: '+963',
    countryCode: 'SY',
    country: 'Syrian Arab Republic',
  },
  {
    label: 'Taiwan, Province of China TW +886',
    value: '+886',
    countryCode: 'TW',
    country: 'Taiwan, Province of China',
  },
  {
    label: 'Tajikistan TJ +992',
    value: '+992',
    countryCode: 'TJ',
    country: 'Tajikistan',
  },
  {
    label: 'Tanzania, United Republic of TZ +255',
    value: '+255',
    countryCode: 'TZ',
    country: 'Tanzania, United Republic of',
  },
  {
    label: 'Thailand TH +66',
    value: '+66',
    countryCode: 'TH',
    country: 'Thailand',
  },
  {
    label: 'Timor-Leste TL +670',
    value: '+670',
    countryCode: 'TL',
    country: 'Timor-Leste',
  },
  {
    label: 'Togo TG +228',
    value: '+228',
    countryCode: 'TG',
    country: 'Togo',
  },
  {
    label: 'Tokelau TK +690',
    value: '+690',
    countryCode: 'TK',
    country: 'Tokelau',
  },
  {
    label: 'Tonga TO +676',
    value: '+676',
    countryCode: 'TO',
    country: 'Tonga',
  },
  {
    label: 'Trinidad and Tobago TT +1868',
    value: '+1868',
    countryCode: 'TT',
    country: 'Trinidad and Tobago',
  },
  {
    label: 'Tunisia TN +216',
    value: '+216',
    countryCode: 'TN',
    country: 'Tunisia',
  },
  {
    label: 'Turkey TR +90',
    value: '+90',
    countryCode: 'TR',
    country: 'Turkey',
  },
  {
    label: 'Turkmenistan TM +993',
    value: '+993',
    countryCode: 'TM',
    country: 'Turkmenistan',
  },
  {
    label: 'Turks and Caicos Islands TC +1649',
    value: '+1649',
    countryCode: 'TC',
    country: 'Turks and Caicos Islands',
  },
  {
    label: 'Tuvalu TV +688',
    value: '+688',
    countryCode: 'TV',
    country: 'Tuvalu',
  },
  {
    label: 'Uganda UG +256',
    value: '+256',
    countryCode: 'UG',
    country: 'Uganda',
  },
  {
    label: 'Ukraine UA +380',
    value: '+380',
    countryCode: 'UA',
    country: 'Ukraine',
  },
  {
    label: 'United Arab Emirates AE +971',
    value: '+971',
    countryCode: 'AE',
    country: 'United Arab Emirates',
  },
  {
    label: 'United Kingdom GB +44',
    value: '+44',
    countryCode: 'GB',
    country: 'United Kingdom',
  },
  {
    label: 'United States US +1',
    value: '+1',
    countryCode: 'US',
    country: 'United States',
  },
  {
    label: 'Uruguay UY +598',
    value: '+598',
    countryCode: 'UY',
    country: 'Uruguay',
  },
  {
    label: 'Uzbekistan UZ +998',
    value: '+998',
    countryCode: 'UZ',
    country: 'Uzbekistan',
  },
  {
    label: 'Vanuatu VU +678',
    value: '+678',
    countryCode: 'VU',
    country: 'Vanuatu',
  },
  {
    label: 'Venezuela VE +58',
    value: '+58',
    countryCode: 'VE',
    country: 'Venezuela',
  },
  {
    label: 'Viet Nam VN +84',
    value: '+84',
    countryCode: 'VN',
    country: 'Viet Nam',
  },
  {
    label: 'Virgin Islands, British VG +1284',
    value: '+1284',
    countryCode: 'VG',
    country: 'Virgin Islands, British',
  },
  {
    label: 'Virgin Islands, U.S. VI +1340',
    value: '+1340',
    countryCode: 'VI',
    country: 'Virgin Islands, U.S.',
  },
  {
    label: 'Wallis and Futuna WF +681',
    value: '+681',
    countryCode: 'WF',
    country: 'Wallis and Futuna',
  },
  {
    label: 'Yemen YE +967',
    value: '+967',
    countryCode: 'YE',
    country: 'Yemen',
  },
  {
    label: 'Zambia ZM +260',
    value: '+260',
    countryCode: 'ZM',
    country: 'Zambia',
  },
  {
    label: 'Zimbabwe ZW +263',
    value: '+263',
    countryCode: 'ZW',
    country: 'Zimbabwe',
  },
];

export const defaultCode = '+43';
